/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = ['.clock-font[_ngcontent-%COMP%] {\n  font-size: x-large;\n  font-weight: 300; }\n\n.clock-username-font[_ngcontent-%COMP%] {\n  font-weight: bold;\n  width: 190px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis; }\n\n.clock-font-date[_ngcontent-%COMP%] {\n  font-size: 0.855em; }'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiRDovaW5ldHB1Yi93d3dyb290L2thaXplbi1uZy9zcmMvYXBwL3RoZW1lL2NvbXBvbmVudHMvY2xvY2svY2xvY2suY29tcG9uZW50LnNjc3Muc2hpbS5uZ3N0eWxlLnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vRDovaW5ldHB1Yi93d3dyb290L2thaXplbi1uZy9zcmMvYXBwL3RoZW1lL2NvbXBvbmVudHMvY2xvY2svY2xvY2suY29tcG9uZW50LnNjc3MiXSwic291cmNlc0NvbnRlbnQiOlsiICJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7OyJ9



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/$$_gendir/app/theme/components/clock/clock.component.scss.shim.ngstyle.ts